module.exports = __webpack_public_path__ + "static/img/bg62.d2de6042.png";